module.exports = __webpack_public_path__ + "media/images/undraw/matching/mobile_messages-023314f6bce308f987961848bb887782.png";